// Fetch product data from the product form
const product = JSON.parse(
    document.querySelector(".product_form").dataset["product"]
);

const url = new URL(window.location.href);
const variantValue = url.searchParams.get("variant");
const selectedVariant = product.variants.find(
    (item) => item.id == variantValue
);

document.addEventListener("DOMContentLoaded", function () {
    // Function to initialize variant selection
    function initializeVariantSelection() {
        const elements = document.getElementsByClassName("single-option-selector");
        const concatenatedValues = Array.from(elements)
            .map((element) => element.value)
            .join(" / ")
            .trim(); // Trim whitespace

        // Log all available variant titles for debugging
        const availableVariants = product.variants.map((v) => v.title.trim());

        const matchingVariant = product.variants.find((item) => {
            // Trim both the variant title and concatenated values for comparison
            return item.title.trim() === concatenatedValues;
        });

        if (!matchingVariant) {
            console.warn(
                "No matching variant found for concatenated values:",
                concatenatedValues
            );
            updateAvailability(null);
            return;
        }

        var size_selected = true;

        for (var i = 0, length = matchingVariant.options.length; i < length; i++) {
            var radioButton = $("#product_form_" + product.id).find(
                '.swatch[data-option-index="' +
                escape(i) +
                '"] :radio[value="' +
                matchingVariant.options[i].replace(/\"/g, '\\"') +
                '"]'
            );

            if (
                radioButton.length &&
                radioButton.get(0).getAttribute("is_input_size_selected") === "false"
            ) {
                radioButton.get(0).checked = true;
            }

            if (size_selected !== false) {
                size_selected = radioButton?.get(0)?.checked ?? false;
            }
        }
        updateAvailability(matchingVariant);
    }

    // Create a MutationObserver to watch for changes in the DOM
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length) {
                // Check if the single-option-selector elements are present
                const elements = document.getElementsByClassName(
                    "single-option-selector"
                );
                if (elements.length > 0) {
                    const urlParams = new URLSearchParams(window.location.search);
                    const variantParam = urlParams.get("variant");
                    if (variantParam) {
                        initializeVariantSelection();
                    }
                    // Disconnect the observer if you only want to run this once
                    observer.disconnect();
                }
            }
        });
    });

    // Start observing the document body for child additions
    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });

    // Optionally, you can also call initializeVariantSelection() immediately if the elements might already be present
    const urlParams = new URLSearchParams(window.location.search);
    const variantParam = urlParams.get("variant");
    if (variantParam) {
        initializeVariantSelection();
    }
    // Function to find the exact variant based on all selected options
    function findExactVariant() {
        const selectedOptions = Array.from(
            document.querySelectorAll(".collection_swatches input:checked")
        ).map((input) => input.value);

        if (selectedOptions.length !== product.options.length) return null;

        const matchedVariant = product.variants.find((variant) => {
            return selectedOptions.every((option, index) => {
                const optionKey = `option${index + 1}`;
                return variant[optionKey] === option;
            });
        });

        return matchedVariant;
    }

    function updateQuantityPickerMax(variant) {
        const $quantityInput = $(".quantity-input");
        if (!$quantityInput.length || !variant) return;
        try {
            const pdPO = document.getElementById(product.id + "pd_po_inventories_hid");
            const pdAI = document.getElementById(product.id + "pd_all_inventories_hid");
            if (!pdPO || !pdAI) return;

            const poInventories = JSON.parse(pdPO.value);
            const allInventories = JSON.parse(pdAI.value);
            const sku = variant.sku || '';
            let policy = variant.inventory_policy;
            if (!policy && variant.id) {
                const variantFromProduct = product.variants.find(v => v.id === variant.id);
                if (variantFromProduct) policy = variantFromProduct.inventory_policy || null;
            }
            if (!policy) {
                const productForm = document.querySelector(".product_form");
                if (productForm && productForm.dataset.variantInventory) {
                    try {
                        const variantInventory = JSON.parse(productForm.dataset.variantInventory);
                        const variantInvData = variantInventory.find(v => v.id === variant.id);
                        if (variantInvData) policy = variantInvData.inventory_policy || null;
                    } catch (e) {}
                }
            }
            const inv = allInventories[sku];
            const inventoryQuantity = parseInt(variant.inventory_quantity) || parseInt(inv) || 0;
            const poInv = poInventories[sku];
            const poInventory = parseInt(poInv) || 0;

            let backorderQty = 0;
            if (inventoryQuantity < 0) {
                backorderQty = Math.abs(inventoryQuantity);
            }

            let remainingPreorder = poInventory - backorderQty;
            if (remainingPreorder < 0) remainingPreorder = 0;

            let maxQuantity;

            const availableQty = Math.max(0, inventoryQuantity);
            const totalPossible = availableQty + remainingPreorder;

            if (policy === "continue" && inventoryQuantity <= 0) {
                if (remainingPreorder > 0) {
                    // Real pre-order (PO exists)
                    maxQuantity = Math.min(totalPossible, 10);
                } else {
                    // Dropship: continue policy, no PO, no stock → allow with safe cap
                    maxQuantity = 10;
                }
            } else {
                // In-stock or mixed inventory → allow full available quantity
                maxQuantity = totalPossible;
            }

            // Enforce max 10 rule
            if (maxQuantity > 10) maxQuantity = 10;

            // If nothing available, block quantity
            if (maxQuantity <= 0) {
                // Dropship case: allow ATC even if no PO inventory
                if (policy === "continue") {
                    maxQuantity = null; // no limit
                } else {
                    maxQuantity = null;
                    // block ATC only when policy is deny
                    const atcBtn = document.querySelector("#pd-add-to-cart");
                    const label = atcBtn.querySelector(".cart-label");
                    if (atcBtn) {
                        atcBtn.setAttribute("disabled", "disabled");
                        atcBtn.classList.add("disabled");
                        label.style.backgroundColor = "grey";
                    }
                }
            }

            // Ensure ATC works for dropship products (policy continue)
            if (policy === "continue") {
                const atcBtn = document.querySelector("#pd-add-to-cart");
                if (atcBtn) {
                    atcBtn.removeAttribute("disabled");
                    atcBtn.classList.remove("disabled");
                    atcBtn.style.cursor = "pointer";
                    const label = atcBtn.querySelector(".cart-label");
                    if (label) label.style.backgroundColor = "";
                }
            }

            if (maxQuantity != null && maxQuantity >= 1) {
                $quantityInput.attr("data-max-quantity", maxQuantity);
                if (policy === "continue" && poInventory >= 1) {
                    $quantityInput.attr("data-is-preorder", "true");
                    $quantityInput.attr("data-po-inventory", maxQuantity);
                } else {
                    $quantityInput.removeAttr("data-is-preorder");
                    $quantityInput.removeAttr("data-po-inventory");
                }
                $quantityInput.attr("data-variant-inventory", inventoryQuantity);
                $quantityInput.attr("data-variant-policy", policy || '');

                $quantityInput.each(function() {
                    const inputEl = this;
                    const setMaxAttribute = function() {
                        if (inputEl && maxQuantity >= 1) {
                            inputEl.setAttribute("max", maxQuantity);
                            inputEl.max = maxQuantity;
                            $(inputEl).prop("max", maxQuantity);
                            $(inputEl).attr("max", maxQuantity);
                        }
                    };
                    setMaxAttribute();
                    if (window.MutationObserver) {
                        if (inputEl._maxObserver) inputEl._maxObserver.disconnect();
                        const observer = new MutationObserver(function(mutations) {
                            mutations.forEach(function(mutation) {
                                if (mutation.type === 'attributes' && mutation.attributeName === 'max') {
                                    const currentMax = inputEl.getAttribute('max');
                                    if (!inputEl.hasAttribute('max') || currentMax !== String(maxQuantity)) setMaxAttribute();
                                }
                            });
                        });
                        observer.observe(inputEl, { attributes: true, attributeFilter: ['max'] });
                        inputEl._maxObserver = observer;
                    }
                });
                setTimeout(function() {
                    $quantityInput.each(function() {
                        const inputEl = this;
                        if (inputEl && maxQuantity >= 1) {
                            inputEl.setAttribute("max", maxQuantity);
                            inputEl.max = maxQuantity;
                            $(inputEl).prop("max", maxQuantity);
                            $(inputEl).attr("max", maxQuantity);
                        }
                    });
                    if (window.PXUTheme && window.PXUTheme.quantityBox && window.PXUTheme.quantityBox.updateQuantityControls) {
                        window.PXUTheme.quantityBox.updateQuantityControls($quantityInput);
                    }
                }, 50);
                if (window.PXUTheme && window.PXUTheme.quantityBox && window.PXUTheme.quantityBox.updateQuantityControls) {
                    window.PXUTheme.quantityBox.updateQuantityControls($quantityInput);
                }
            } else {
                $quantityInput.removeAttr("max");
                $quantityInput.removeAttr("data-max-quantity");
                $quantityInput.removeAttr("data-is-preorder");
                $quantityInput.removeAttr("data-po-inventory");
                if (window.PXUTheme && window.PXUTheme.quantityBox && window.PXUTheme.quantityBox.updateQuantityControls) {
                    window.PXUTheme.quantityBox.updateQuantityControls($quantityInput);
                }
            }
        } catch (e) {
            console.error('Error updating quantity picker:', e);
        }
    }

    function updateAvailability(variant) {
        const bt = document.getElementById("pd-add-to-cart-button");
        const bt_main = document.getElementById("pd-add-to-cart");
        // const sp = document.getElementById("pd-add-to-cart-message");
        const sp = document.getElementById("pd-add-to-cart-message");
        const sp2 = document.getElementById("pd-add-to-cart-message2");
        const quantityWrapper = document.querySelector(".purchase-details__quantity.product-quantity-box.quantity-box--box");
        const skuElement = document.querySelector(".sku");
        if (skuElement && variant) {
            skuElement.textContent = variant && variant.sku ? variant.sku : '';
        }
      const purchase_button = document.querySelector('.purchase-details__buttons');

        const collectionSwatches = document.querySelectorAll(".collection_swatches");
        const allOptionsSelectedBase = Array.from(collectionSwatches).every((group) => {
            return group.querySelector("input:checked") !== null;
        });
        const hasOptionInputs = document.querySelectorAll(".collection_swatches input").length > 0;
        const singleOptionVariant = product.options.length === 1
            ? (findExactVariant() || (!hasOptionInputs ? product.variants[0] : null))
            : null;
        const allOptionsSelected = allOptionsSelectedBase || (product.options.length === 1 && singleOptionVariant != null);

        if (!allOptionsSelected) {
            if (bt) bt.innerHTML = "SELECT SIZE/COLOR";
            if (bt_main) {
              bt_main.disabled = true;
              bt_main.classList.remove("ajax-submit", "action_button");
              bt_main.classList.add("disabled");
              bt_main.style.cursor = "not-allowed";
            }
            if (bt) bt.style.backgroundColor = "black";
            if (purchase_button) purchase_button.classList.remove("unavailable");
            if (sp) sp.innerHTML = "";
            setQuantityEnabled(false);
            return;
        }

        if (product.options.length === 1 && !variant && singleOptionVariant) variant = singleOptionVariant;

        // Check if the variant is available
        if (variant && variant.available) {
            //remove class unavailable when the variants is available(add-to-cart-button)
            purchase_button.classList.remove('unavailable');
            // Add image variant feature
            if (variant && variant.featured_image) {
                const $product = $('.product-gallery');
                const $sliders = $(".product-gallery__main", $product);

                $sliders.each((_index, value) => {
                    const $slider = $(value);
                    const $sliderInstance = window.Flickity.data(value);
                    // Find the matching image div by product-id and media-id
                    const index = $(`.product-gallery__image[data-media-type="image"] img[data-image-id="${variant.featured_media.id}"]`).closest('.product-gallery__image').index();

                    if ($slider.is(":visible") && $sliderInstance !== undefined && index !== -1) {
                        $sliderInstance.select(index, false, true);
                    }
                });
            }

            // Logic for when the variant is available
            if (variant.price < variant.compare_at_price) {
                $(".was-price").html(
                    '<span class="money">' +
                    Shopify.formatMoney(
                        variant.compare_at_price,
                        $("body").data("money-format")
                    ) +
                    "</span>"
                );
                $(".savings").html(
                    window.PXUTheme.translation.product_savings +
                    " " +
                    parseInt(
                        ((variant.compare_at_price - variant.price) * 100) /
                        variant.compare_at_price
                    ) +
                    "% (" +
                    '<span class="money">' +
                    Shopify.formatMoney(
                        variant.compare_at_price - variant.price,
                        $("body").data("money-format")
                    ) +
                    "</span>)"
                );
                $(".current_price").parent().addClass("sale");
            } else {
                $(".was-price").html("");
                $(".savings").html("");
                $(".current_price").parent().removeClass("sale");
            }

            if (variant.inventory_management && variant.inventory_quantity > 0) {
                if (window.PXUTheme.theme_settings.display_inventory_left) {
                    let items_left_text = window.PXUTheme.translation.product_count_other;

                    if (variant.inventory_quantity === 1) {
                        items_left_text = window.PXUTheme.translation.product_count_one;
                    }

                    const inventoryThreshold =
                        window.PXUTheme.theme_settings.inventory_threshold;

                    if (variant.inventory_quantity <= inventoryThreshold) {
                        $(".items_left").html(
                            variant.inventory_quantity + " " + items_left_text
                        );
                    } else {
                        $(".items_left").html("");
                    }
                }

                if (variant.inventory_policy === "deny") {
                    $("[data-max-inventory-management]").attr(
                        "max",
                        variant.inventory_quantity
                    );
                    window.PXUTheme.theme.quantityBox.updateQuantityControls(
                        $productFormInput
                    );
                }
            } else {
                $(".items_left").text("");
                $("[data-max-inventory-management]").removeAttr("max");
            }

            $(".sold_out").text("");
            $(".cart-warning").text("");

            if (variant.price > 0) {
                $(".current_price").html(
                    '<span class="money">' +
                    Shopify.formatMoney(variant.price, $("body").data("money-format")) +
                    "</span>"
                );
            } else {
                $(".current_price").html(window.PXUTheme.translation.free_price_text);
            }

            $("[data-add-to-cart-trigger]")
                .removeClass("disabled")
                .removeAttr("disabled")
                .find("span:not(.icon)")
                .text($("[data-add-to-cart-trigger]").data("label"));
            $(".shopify-payment-button").show();
            $(".purchase-details__quantity").show();

          //pre-order
      const pdMD = document.getElementById(product.id + "pd_meta_data_hid");
      const sku = variant?.sku || '';
      const metaData = JSON.parse(pdMD.value);
      const future_avail = metaData[sku];
      const pdAI = document.getElementById(product.id + "pd_all_inventories_hid");
      const allInventories = JSON.parse(pdAI.value);
      const inv = allInventories[sku];
      const intInv = parseInt(inv);

        var countryCode = window.shopifyData?.countryCode || 'US';
        var bolIsInternational = countryCode !== 'US' ? 1 : 0;

        if (
            bolIsInternational == 1 &&
            intInv <= 0
            ) {
            if (bt) {
                bt.innerHTML = "Unavailable for International Shipping";
                bt.disabled = true;
                bt.style.backgroundColor = "grey";
            }

            if (bt_main) {
                bt_main.classList.remove("ajax-submit", "action_button");
                bt_main.classList.add("disabled");
                bt_main.style.cursor = "not-allowed";
            }

            if (sp) sp.innerHTML = "";
            if (sp2) {
                sp2.innerHTML =
                "This item is not available for international shipping, but may be available soon. Check back at a later date.";
            }

            return;
        }

      if (intInv <= 0 && future_avail != null && future_avail != '') {
        if (bt) bt.innerHTML = "PRE-ORDER NOW!";
        if (bt) bt.disabled = false;  //not sure if we need this                 
        if (sp) sp.innerHTML = "Estimated to ship the week of " + future_avail
        if (bt_main) {
          bt_main.classList.add("ajax-submit", "action_button");
          bt_main.classList.remove("disabled");
          bt_main.style.cursor = "pointer";
        }
        // console.log("CodeHere8965")
        if (bt) bt.style.backgroundColor = "black";
            updateQuantityPickerMax(variant);
            return;
        } else {
          if (sp) sp.innerHTML = "";
        }

        } else {
            // If the variant is not available or undefined
            let message = variant
                ? window.PXUTheme.translation.soldOut
                : window.PXUTheme.translation.unavailable;

            // Clear previous messages
            $(".was-price").text("");
            $(".savings").text("");
            $(".current_price").text("");
            $(".items_left").text("");
            $("[data-max-inventory-management]").removeAttr("max");

            // // Set the sold out message
            $(".sold_out").text(message);

            if (!variant || !variant.available) {
              if (bt) bt.innerHTML = "UNAVAILABLE";
              if (bt_main) {
                bt_main.disabled = true;
                bt_main.classList.remove("ajax-submit", "action_button");
                bt_main.classList.add("disabled");
                bt_main.setAttribute("disabled", "disabled");
                bt_main.style.cursor = "not-allowed";
                sp.innerHTML = "";
                sp2.innerHTML = "";
              }
              if (bt) bt.style.backgroundColor = "grey";
              if (purchase_button) purchase_button.classList.add('unavailable');
              if (quantityWrapper) quantityWrapper.style.display = "none";
              return;
            }
            // Hide payment button and quantity details
            $(".shopify-payment-button").hide();
            $(".purchase-details__quantity").hide();
        }

        // Additional logic for button state and other UI elements
        if (!bt || !bt_main) {
            console.error("Critical DOM elements missing");
            return;
        }
        if (quantityWrapper) {
            quantityWrapper.style.display = "flex";
        }

        if (bt) bt.innerHTML = "ADD TO CART";
        if (bt_main) {
          bt_main.disabled = false;
          bt_main.classList.add("ajax-submit", "action_button");
          bt_main.classList.remove("disabled");
          bt_main.style.cursor = "pointer";
          sp.innerHTML = "";
          sp2.innerHTML = "";
        }
        if (bt) bt.style.backgroundColor = "black";

        setQuantityEnabled(true);
        /* if (variant && typeof SetAvailabilityMessage === 'function') {
            console.log('variant: ', variant.inventory_policy);
            try {
                const pdPO = document.getElementById(product.id + "pd_po_inventories_hid");
                const poInventories = pdPO ? JSON.parse(pdPO.value) : {};
                const poInventory = poInventories[variant.sku] || 0;
                const prodTags = product.tags || [];
                const exc = prodTags.indexOf('exc_pre-order') !== -1;
                const r_one = prodTags.indexOf('R1_Message') !== -1;
                
                SetAvailabilityMessage(
                    variant.sku,
                    product.id,
                    variant.inventory_policy,
                    poInventory,
                    exc,
                    r_one,
                    'VARIANT_SELECTED'
                );
            } catch (e) {
                console.error('Error calling SetAvailabilityMessage:', e);
            }
        } */
        // console.log("Code Here741");
        updateQuantityPickerMax(variant);
        // console.log("Code Here852");
    }

    // Add event listeners to all option selectors
    function addOptionSelectionListeners() {
        const optionSelectors = document.querySelectorAll(".swatch_options input");

        const inputs = document.querySelectorAll(".swatch_options input, .collection_swatches input");
        inputs.forEach((selector) => {
            selector.addEventListener("change", function () {
                setTimeout(() => {
                    const exactVariant = findExactVariant();
                    updateAvailability(exactVariant);
                    setQuantityEnabled(isFullVariantSelected());

                    if (exactVariant) {
                        const newUrl = new URL(window.location.href);
                        newUrl.searchParams.set("variant", exactVariant.id);
                        window.history.replaceState(null, null, newUrl.toString());
                    }
                }, 50);
            });
        });
    }

    // Initial setup
    function initializeProductVariants() {
        // Only select options and update availability if a variant parameter exists in the URL
        if (variantValue && selectedVariant) {
            updateAvailability(selectedVariant);
        } else {
          // Get all swatch containers
          const swatchContainers = document.querySelectorAll(".options-swatch");
          
          // Check first button in first swatch group (index 0)
          if (swatchContainers[0]) {
              const firstGroupButton = swatchContainers[0].querySelector('button, input[type="radio"]');
              if (firstGroupButton) {
                  if (firstGroupButton.type === 'radio') {
                      firstGroupButton.checked = true;
                  } else {
                      firstGroupButton.setAttribute('aria-checked', 'true');
                  }
              }
          }


          //update either lengthtext or inseam text if present
            if (swatchContainers[2]) {
                const thirdGroupButton = swatchContainers[2].querySelector('input[type="radio"]');
                if (thirdGroupButton) {
                    thirdGroupButton.checked = true;
                    const value = thirdGroupButton.getAttribute('value');
                    
                    // Check for lengthtext
                    const lengthText = document.getElementById('lengthtext');
                    if (lengthText && value) {
                        lengthText.innerHTML = value;
                    }
                    
                    // Check for inseamtext
                    const inseamText = document.getElementById('inseamtext');
                    if (inseamText && value) {
                        inseamText.innerHTML = value;
                    }
                }
            }
            // Set default button state
            updateAvailability(null);
        }
        if (product.options.length === 1) {
            const firstChecked = document.querySelector(".collection_swatches input:checked");
            if (!firstChecked) {
                const firstInput = document.querySelector(".collection_swatches input");
                if (firstInput) firstInput.checked = true;
            }
            const singleOptionVariant = findExactVariant();
            updateAvailability(singleOptionVariant);
        }

        addOptionSelectionListeners();
        setQuantityEnabled(isFullVariantSelected());
    }

    function isFullVariantSelected() {
        const checkedCount = document.querySelectorAll(".collection_swatches input:checked").length;
        const exact = findExactVariant();
        if (product.options.length === 1) {
            const hasOptionInputs = document.querySelectorAll(".collection_swatches input").length > 0;
            if (!hasOptionInputs) return product.variants.length > 0;
        }
        return checkedCount === product.options.length && exact != null;
    }

    function setQuantityEnabled(enabled) {
        const plus = document.querySelector(".quantity-plus");
        const minus = document.querySelector(".quantity-minus");
        const quantityInput = document.querySelector(".quantity-input");
        if (!plus || !minus) return;
        if (enabled) {
            plus.removeAttribute("disabled");
            minus.removeAttribute("disabled");
            if (quantityInput) quantityInput.removeAttribute("disabled");
        } else {
            plus.setAttribute("disabled", "disabled");
            minus.setAttribute("disabled", "disabled");
            if (quantityInput) quantityInput.setAttribute("disabled", "disabled");
        }
    }

    initializeProductVariants();
});